<script setup lang="ts">
import type { FaqPage } from "./FaqTypes"

const props = defineProps<{
    pages: FaqPage[]
    selectedPage: FaqPage | null
}>()

const emit = defineEmits<{
    (event: "page-selected", page: FaqPage): void
}>()
</script>
<template>
    <div
        v-for="(page, index) in props.pages"
        :key="index"
        class="accordion-enumeration-menu-item"
        :class="{ active: props.selectedPage === page }"
        @click="emit('page-selected', page)"
    >
        {{ page.name }}
    </div>
</template>
